/* ==========================================================================
   SCRT — shop behaviour
   Cart drawer · Choose options modal · header predictive search

   Dependency-free, idempotent, and progressive: every entry point is a real
   link or a real form POST first, upgraded here. With JS off you still get the
   cart page, the product page and the search results page.
   ========================================================================== */

(function () {
  'use strict';

  if (window.SCRTShop) return;
  window.SCRTShop = { version: '1.0.0' };

  var CART_SECTION = 'scrt-cart-drawer';
  var OPTIONS_SECTION = 'scrt-product-options';
  var SEARCH_SECTION = 'scrt-predictive-search';
  var SEARCH_DEBOUNCE = 220;

  var routes = window.SCRTRoutes || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function $$(sel, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(sel));
  }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }

  /* --------------------------------------------------------------------
     Overlay plumbing — shared by the drawers and the modal
     -------------------------------------------------------------------- */

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  var openLayer = null;
  var lastFocused = null;

  function trapFocus(e) {
    if (!openLayer || e.key !== 'Tab') return;
    var panel = $('.scrt-drawer__panel, .scrt-modal__panel', openLayer);
    if (!panel) return;
    var items = $$(FOCUSABLE, panel).filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function onKeydown(e) {
    if (e.key === 'Escape') closeLayer();
    trapFocus(e);
  }

  function openLayerEl(el, focusSel) {
    if (!el) return;
    if (openLayer && openLayer !== el) closeLayer();
    lastFocused = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('scrt-no-scroll');
    openLayer = el;
    document.addEventListener('keydown', onKeydown);

    var target = focusSel ? $(focusSel, el) : null;
    if (!target) target = $(FOCUSABLE, $('.scrt-drawer__panel, .scrt-modal__panel', el) || el);
    if (target) {
      // Wait a frame so the panel has begun its transform, or Safari scrolls the
      // page to where the panel used to be.
      requestAnimationFrame(function () { target.focus({ preventScroll: true }); });
    }
  }

  function closeLayer() {
    if (!openLayer) return;
    openLayer.classList.remove('is-open');
    openLayer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('scrt-no-scroll');
    document.removeEventListener('keydown', onKeydown);
    openLayer = null;
    if (lastFocused && lastFocused.focus) lastFocused.focus({ preventScroll: true });
    lastFocused = null;
  }

  window.SCRTShop.close = closeLayer;

  /* --------------------------------------------------------------------
     Cart
     -------------------------------------------------------------------- */

  function cartDrawer() { return $('[data-scrt-cart-drawer]'); }

  function openCart() {
    var el = cartDrawer();
    if (!el) { window.location.href = routes.cart || '/cart'; return; }
    openLayerEl(el);
  }

  function announce(msg) {
    var live = $('[data-scrt-live]');
    if (!live) {
      live = document.createElement('p');
      live.setAttribute('data-scrt-live', '');
      live.setAttribute('aria-live', 'polite');
      live.className = 'scrt-visually-hidden';
      document.body.appendChild(live);
    }
    live.textContent = msg;
  }

  /* Re-render the drawer from the server rather than patching it here, so the
     markup can never disagree with the real cart. */
  function refreshCart(openAfter) {
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + '?sections=' + CART_SECTION
        : '/?sections=' + CART_SECTION)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[CART_SECTION];
        if (!html) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html');
        var next = $('[data-scrt-cart-drawer]', fresh);
        var current = cartDrawer();
        if (next && current) {
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = next.innerHTML;
          current.setAttribute('data-cart-count', next.getAttribute('data-cart-count') || '0');
          if (wasOpen) current.classList.add('is-open');
          syncCount(parseInt(next.getAttribute('data-cart-count'), 10) || 0);
        }
        if (openAfter) openCart();
      })
      .catch(function () {
        // Network trouble: send them to the real cart page rather than lying.
        if (openAfter) window.location.href = routes.cart || '/cart';
      });
  }

  function syncCount(count) {
    $$('[data-scrt-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
    // Let Taiga (or any app) update its own cart UI too.
    ['cart:updated', 'cart:refresh', 'cart:build', 'cart:change', 'product:added'].forEach(function (name) {
      document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { count: count } }));
    });
    if (window.jQuery) { try { window.jQuery(document).trigger('cart:refresh'); } catch (e) {} }
  }

  function setBusy(btn, busy, busyLabel) {
    if (!btn) return;
    if (busy) {
      btn.dataset.scrtLabel = btn.innerHTML;
      btn.disabled = true;
      btn.classList.add('is-busy');
      if (busyLabel) btn.innerHTML = '<span>' + busyLabel + '</span>';
    } else {
      btn.disabled = false;
      btn.classList.remove('is-busy');
      if (btn.dataset.scrtLabel) { btn.innerHTML = btn.dataset.scrtLabel; delete btn.dataset.scrtLabel; }
    }
  }

  function addToCart(formData, btn, okLabel) {
    setBusy(btn, true, 'Adding…');
    return fetch(routes.cartAdd || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        setBusy(btn, false);
        if (!res.ok) {
          var msg = (res.body && (res.body.description || res.body.message)) || 'Could not add that item.';
          showError(btn, msg);
          announce(msg);
          return false;
        }
        announce((okLabel || 'Added to cart') + '.');
        return refreshCart(true).then(function () { return true; });
      })
      .catch(function () {
        setBusy(btn, false);
        showError(btn, 'Network error. Please try again.');
        return false;
      });
  }

  function showError(nearBtn, msg) {
    var box = nearBtn && nearBtn.closest('form')
      ? $('[data-scrt-options-error]', nearBtn.closest('form'))
      : null;
    if (box) {
      box.textContent = msg;
      box.removeAttribute('hidden');
      return;
    }
    announce(msg);
  }

  function changeLine(line, quantity) {
    var drawer = cartDrawer();
    if (drawer) drawer.classList.add('is-loading');
    return fetch(routes.cartChange || '/cart/change', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function () { return refreshCart(false); })
      .catch(function () { window.location.href = routes.cart || '/cart'; })
      .then(function () { if (drawer) drawer.classList.remove('is-loading'); });
  }

  /* --------------------------------------------------------------------
     Choose options modal
     -------------------------------------------------------------------- */

  function modal() { return $('[data-scrt-modal]'); }

  function openOptions(url, trigger) {
    var el = modal();
    if (!el) { window.location.href = url; return; }

    var mount = $('[data-scrt-modal-mount]', el);
    mount.innerHTML = '<div class="scrt-modal__loading"><span></span><span></span><span></span></div>';
    openLayerEl(el);
    lastFocused = trigger || lastFocused;

    var sep = url.indexOf('?') > -1 ? '&' : '?';
    fetch(url + sep + 'section_id=' + OPTIONS_SECTION)
      .then(function (r) {
        if (!r.ok) throw new Error('bad response');
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = $('[data-scrt-options]', doc);
        if (!content) throw new Error('no options markup');
        mount.innerHTML = '';
        mount.appendChild(document.importNode(content, true));
        bindOptions(mount);
        var first = $(FOCUSABLE, mount);
        if (first) first.focus({ preventScroll: true });
      })
      .catch(function () {
        // Never strand them in an empty modal — hand off to the product page.
        window.location.href = url;
      });
  }

  function bindOptions(scope) {
    var root = $('[data-scrt-options]', scope);
    if (!root) return;

    var dataEl = $('[data-scrt-options-data]', root);
    var data = null;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { data = null; }
    if (!data) return;

    var idField = $('[data-scrt-options-id]', root);
    var priceEl = $('[data-scrt-options-price]', root);
    var stockEl = $('[data-scrt-options-stock]', root);
    var submit = $('[data-scrt-options-submit]', root);
    var label = $('[data-scrt-options-submit-label]', root);
    var image = $('[data-scrt-options-image]', root);

    function selection() {
      return $$('[data-scrt-option-value]', root)
        .filter(function (r) { return r.checked; })
        .map(function (r) { return r.value; });
    }

    function match(sel) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        var same = v.options.length === sel.length;
        for (var j = 0; same && j < sel.length; j++) {
          if (v.options[j] !== sel[j]) same = false;
        }
        if (same) return v;
      }
      return null;
    }

    function update() {
      var sel = selection();
      var v = sel.length ? match(sel) : data.variants[0];

      $$('[data-scrt-option-chosen]', root).forEach(function (el, i) {
        if (sel[i]) el.textContent = sel[i];
      });

      if (!v) {
        if (submit) submit.disabled = true;
        if (label) label.textContent = 'Unavailable';
        if (stockEl) stockEl.innerHTML = '<span class="scrt-options__dot scrt-options__dot--out"></span>Not available';
        return;
      }

      if (idField) idField.value = v.id;

      if (priceEl) {
        priceEl.innerHTML = v.compare_at_price && v.compare_at_price > v.price
          ? '<span class="scrt-card__price-now scrt-card__price-now--sale">' + v.price_formatted +
            '</span> <s class="scrt-card__price-was">' + v.compare_at_formatted + '</s>'
          : '<span class="scrt-card__price-now">' + v.price_formatted + '</span>';
      }

      if (stockEl) {
        stockEl.innerHTML = v.available
          ? '<span class="scrt-options__dot scrt-options__dot--in"></span>In stock'
          : '<span class="scrt-options__dot scrt-options__dot--out"></span>Sold out';
      }

      if (submit) submit.disabled = !v.available;
      if (label) label.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (image && v.image) image.src = v.image;

      // Deep-link the URL so a refresh or a shared link keeps the choice.
      if (window.history && window.history.replaceState && data.url) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u);
        } catch (e) {}
      }
    }

    $$('[data-scrt-option-value]', root).forEach(function (r) { on(r, 'change', update); });

    $$('[data-scrt-options-qty]', root).forEach(function (btn) {
      on(btn, 'click', function () {
        var input = $('[data-scrt-options-qty-input]', root);
        if (!input) return;
        var next = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-scrt-options-qty'), 10);
        input.value = Math.max(1, next);
      });
    });

    var form = $('[data-scrt-options-form]', root);
    on(form, 'submit', function (e) {
      e.preventDefault();
      var err = $('[data-scrt-options-error]', root);
      if (err) err.setAttribute('hidden', '');
      // No closeLayer() here: a successful add opens the cart drawer, and
      // openLayerEl closes whatever layer was open first. Closing again would
      // shut the drawer the customer just asked for.
      addToCart(new FormData(form), submit, 'Added to cart');
    });

    update();
  }

  /* --------------------------------------------------------------------
     Predictive search
     -------------------------------------------------------------------- */

  var searchTimer = null;
  var searchAbort = null;

  function searchDrawer() { return $('[data-scrt-search-drawer]'); }

  function openSearch() {
    var el = searchDrawer();
    if (!el) { window.location.href = routes.search || '/search'; return; }
    openLayerEl(el, '[data-scrt-search-input]');
  }

  function runSearch(term) {
    var mount = $('[data-scrt-search-mount]');
    var spinner = $('[data-scrt-search-spinner]');
    var input = $('[data-scrt-search-input]');
    if (!mount) return;

    if (!term || term.length < 2) {
      mount.innerHTML = '<p class="scrt-search__hint">Start typing to search the store.</p>';
      if (input) input.setAttribute('aria-expanded', 'false');
      return;
    }

    if (searchAbort) searchAbort.abort();
    searchAbort = ('AbortController' in window) ? new AbortController() : null;

    if (spinner) spinner.removeAttribute('hidden');

    var url = (routes.predictiveSearch || '/search/suggest') +
      '?q=' + encodeURIComponent(term) +
      '&resources[type]=product,collection,article,page' +
      '&resources[limit]=6' +
      '&resources[options][unavailable_products]=last' +
      '&section_id=' + SEARCH_SECTION;

    fetch(url, searchAbort ? { signal: searchAbort.signal } : undefined)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var results = $('[data-scrt-search-results]', doc);
        mount.innerHTML = results ? results.innerHTML : '<p class="scrt-search__empty">No matches.</p>';
        if (spinner) spinner.setAttribute('hidden', '');
        if (input) input.setAttribute('aria-expanded', 'true');
        var count = $$('[data-scrt-search-item]', mount).length;
        announce(count ? count + ' results for ' + term : 'No results for ' + term);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (spinner) spinner.setAttribute('hidden', '');
        mount.innerHTML = '<p class="scrt-search__empty">Search is unavailable right now. ' +
          '<a href="' + (routes.search || '/search') + '?q=' + encodeURIComponent(term) + '">Open the search page</a>.</p>';
      });
  }

  /* --------------------------------------------------------------------
     Wiring
     -------------------------------------------------------------------- */

  function init() {
    // Openers, delegated so sections re-rendered by the editor keep working.
    on(document, 'click', function (e) {
      var cartBtn = e.target.closest('[data-scrt-cart-open]');
      if (cartBtn) { e.preventDefault(); openCart(); return; }

      var searchBtn = e.target.closest('[data-scrt-search-open]');
      if (searchBtn) { e.preventDefault(); openSearch(); return; }

      var closeBtn = e.target.closest('[data-scrt-drawer-close], [data-scrt-modal-close]');
      if (closeBtn && closeBtn.closest('[data-scrt-cart-drawer], [data-scrt-search-drawer], [data-scrt-modal]')) {
        e.preventDefault(); closeLayer(); return;
      }

      var optBtn = e.target.closest('[data-scrt-options-open]');
      if (optBtn) {
        e.preventDefault();
        openOptions(optBtn.getAttribute('data-scrt-options-open') || optBtn.href, optBtn);
        return;
      }

      var qtyBtn = e.target.closest('[data-scrt-qty-change]');
      if (qtyBtn) {
        e.preventDefault();
        changeLine(
          parseInt(qtyBtn.getAttribute('data-scrt-qty-change'), 10),
          parseInt(qtyBtn.getAttribute('data-scrt-qty-to'), 10)
        );
        return;
      }

      var clearBtn = e.target.closest('[data-scrt-search-clear]');
      if (clearBtn) {
        e.preventDefault();
        var input = $('[data-scrt-search-input]');
        if (input) { input.value = ''; input.focus(); }
        clearBtn.setAttribute('hidden', '');
        runSearch('');
        return;
      }
    });

    // Quick add straight from a card.
    on(document, 'submit', function (e) {
      var form = e.target.closest('[data-scrt-quick-add]');
      if (!form) return;
      e.preventDefault();
      addToCart(new FormData(form), $('button[type="submit"]', form), 'Added to cart');
    });

    document.addEventListener('ajaxProduct:added', function () {
      refreshCart(true);
    });

    // Typed quantity in the drawer.
    on(document, 'change', function (e) {
      var input = e.target.closest('[data-scrt-qty-input]');
      if (!input) return;
      changeLine(
        parseInt(input.getAttribute('data-scrt-qty-input'), 10),
        Math.max(0, parseInt(input.value, 10) || 0)
      );
    });

    // Debounced predictive search.
    on(document, 'input', function (e) {
      var input = e.target.closest('[data-scrt-search-input]');
      if (!input) return;
      var clear = $('[data-scrt-search-clear]');
      if (clear) {
        if (input.value) clear.removeAttribute('hidden'); else clear.setAttribute('hidden', '');
      }
      clearTimeout(searchTimer);
      var term = input.value.trim();
      searchTimer = setTimeout(function () { runSearch(term); }, SEARCH_DEBOUNCE);
    });

    // Enter submits to the full results page rather than picking a guess.
    on(document, 'keydown', function (e) {
      if (e.key !== 'Enter') return;
      var input = e.target.closest('[data-scrt-search-input]');
      if (!input) return;
      var form = input.closest('form');
      if (form) { clearTimeout(searchTimer); form.submit(); }
    });

    // Theme editor re-renders a section: rebind anything inside it.
    document.addEventListener('shopify:section:load', function (e) {
      if ($('[data-scrt-options]', e.target)) bindOptions(e.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.SCRTShop.openCart = openCart;
  window.SCRTShop.openSearch = openSearch;
  window.SCRTShop.openOptions = openOptions;
  window.SCRTShop.refreshCart = refreshCart;
})();
